"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectManagementOrganizationComponent = void 0;
const core_1 = require("@angular/core");
const connect_organization_1 = require("./connect-organization");
let ConnectManagementOrganizationComponent = class ConnectManagementOrganizationComponent {
    constructor() {
        this.onSelected = new core_1.EventEmitter();
        this.onReset = new core_1.EventEmitter();
    }
    type(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (value) {
                this.organizations = yield connect_organization_1.ConnectOrganization.autocomplete(value);
            }
            else {
                this.organizations = null;
            }
        });
    }
    select(organization) {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            this.organizations = null;
            this.name = organization.displayName;
            this.onSelected.emit(organization);
        });
    }
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            this.organizations = null;
            this.name = null;
            this.onReset.emit();
        });
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            let organization = new connect_organization_1.ConnectOrganization({
                displayName: this.autocomplete,
            });
            try {
                organization = yield organization.create();
                this.reset();
                this.select(organization);
                this.toast("Successfully Created Organization!");
            }
            catch (err) {
                this.error = err;
            }
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.error = null;
            try {
                let organization = yield this.organization.update();
                this.reset();
                this.select(organization);
                this.toast("Successfully Updated Organization!");
            }
            catch (err) {
                this.error = err;
            }
        });
    }
    creatable() {
        return !this.organization;
    }
    updatable() {
        return !!this.organization;
    }
    toast(message) {
        this.success = message;
        setTimeout(() => {
            this.success = null;
        }, 5000);
    }
};
exports.ConnectManagementOrganizationComponent = ConnectManagementOrganizationComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", connect_organization_1.ConnectOrganization)
], ConnectManagementOrganizationComponent.prototype, "organization", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], ConnectManagementOrganizationComponent.prototype, "onSelected", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", core_1.EventEmitter)
], ConnectManagementOrganizationComponent.prototype, "onReset", void 0);
exports.ConnectManagementOrganizationComponent = ConnectManagementOrganizationComponent = __decorate([
    (0, core_1.Component)({
        selector: "connect-management-organization",
        templateUrl: "app/connect-management-organization.component.html",
    }),
    (0, core_1.Injectable)()
], ConnectManagementOrganizationComponent);
//# sourceMappingURL=connect-management-organization.component.js.map